import React, { Component } from 'react';
import {UISref,UISrefActive} from 'ui-router-react'; 

class Submenu extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);		
		this.state = {
			status: '',
			privateClass:this.props.privateClass
		}
	}
	handleClick(){		
		if(window.innerWidth<768){
			let status = (this.state.status==="") ? 'submenu-open' : '';
			this.setState({
				status: status
			});
		}
	}
	componentWillMount(){
		if(localStorage.getItem('password')!==null){
			this.setState({
				privateClass:'public'
			});
		}
	}
	componentWillReceiveProps(nextProps) {
	  // You don't have to do this check first, but it can help prevent an unneeded render
	  if (nextProps.privateClass !== this.state.privateClass) {
		this.setState({ privateClass: nextProps.privateClass });
	  }
	}
	render(){
		let menuName = this.props.menuName;
		return(
			<div className={`submenu-section-wrapper submenu-${menuName}`}>
				<ul role="menu" aria-label="Sub Navigation" className={`submenu-section ${this.state.status}`}>
					<i className="icon-expand-white" onClick={this.handleClick}></i>
					{
						this.props.menuItems.map( (data,i)=>{
							if(data.classes===menuName){
								return	data.children.map( (child,j)=>{								
											return <UISrefActive  class="active " key={j}>
														<UISref to={"root."+menuName+"."+child.classes}>
															<li className={this.state.privateClass} id={`submenu-${child.classes}`} role="menuitem" ><a onClick={this.handleClick}>{child.title}</a></li> 
														</UISref>	 
													</UISrefActive>
													
										})
							}else
								return '';
						})
					}
				</ul>
			</div>
		)
	}	
}
export default Submenu;


// WEBPACK FOOTER //
// ./src/components/Submenu.js